<!--
 * @Author:
 * @LastEditTime: 2023-07-28
 * @Description: 承包商开工许可指引
-->
<template>
  <el-card class="h-full relative">
    <div class="h-full">
      <div class="h-full flex flex-col">
        <div class="flex-1 overflow-y-auto bg_custom">
          <div :key="index" v-for="(typeItem, index) in sortAptitudeList" class="overflow-hidden">
            <h3 class="text-center my-15px font-bold">{{ typeItem.directoryName }}</h3>
            <div
              :key="ind"
              v-for="(item, ind) in typeItem.child"
              class="flex mb-10px rounded bg-color-main m-15px p-10px"
            >
              <div class="flex-1">
                <h5 class="font-bold text-15px mb-5px">
                  <span v-show="!!item.isProvided" class="required-text--color">*</span
                  >{{ `${ind + 1}.${item.title}` }}
                </h5>
                <div class="text-14px text-warmGray-400">{{ item.titleContent }}</div>
              </div>
              <span
                class="down-file--color mr-15px ml-30px text-right mr-20px cursor-pointer"
                @click="viewFile(item)"
              >
                <!-- 示例下载 -->
                查看示例
              </span>
              <span
                class="down-file--color text-right mr-20px cursor-pointer"
                @click="downLoadFile(item)"
              >
                <!-- 示例下载 -->
                下载示例
              </span>
            </div>
          </div>
        </div>
        <div class="pt-18px pb-60px font-bold text-14px text-justify">
          为了方便资料收集，您可以点击<!--
           --><span class="text-color-primary">下载人员入厂申报指引模板</span
          ><!--
          -->收集数据，若您收集完用户数据后请按照以下要求导入模板数据，具体要求如下：将<!--
           --><span class="text-color-primary">人员入厂指引模板</span
          ><!--
          -->文件放到PDF中，在【人员入厂申报】模块中进行导入。
        </div>
        <div class="text-center">
          <el-button size="small" type="primary" @click="createApi()">已准备好</el-button>
          <el-button size="small" @click="refreshList">返回准备</el-button>
        </div>
      </div>
      <operate-api-dialog
        :contractorId="contractorId"
        v-if="showOperateApiDialog"
        ref="operateApiDialog"
        :templateId="templateId"
        :operateApiProps="operateApiProps"
        @refreshList="refreshList"
        @cancel="showOperateApiDialog = false"
      ></operate-api-dialog>
      <el-dialog class="img_dialog" :visible.sync="dialogVisible" append-to-body>
        <img :src="imgContent" class="w-full" alt="" />
      </el-dialog>
    </div>
  </el-card>
</template>

<script type="text/babel">
import {
  WorkPermitApi,
  ProfileTemplateGuidanceConfigurationApi,
} from '@wiz-api/contractor-management'
import { FileApi } from '@wiz-api/file-management'

const fileApi = new FileApi()

const workPermitApi = new WorkPermitApi()
const profileTemplateGuidanceConfigurationApi = new ProfileTemplateGuidanceConfigurationApi()

const OperateApiDialog = () => {
  return import('../components/OperateApiDialog')
}
export default {
  name: 'contractor-start-guidelines',
  components: {
    OperateApiDialog,
  },
  props: ['contractorId', 'profileTemplateId'],
  data() {
    return {
      permitsId: '',
      showOperateApiDialog: false,
      operateApiProps: {
        title: '开工许可申请',
        editType: 'create',
        visible: true,
      },
      aptitudeList: [],
      // 图片预览信息
      imgContent: null,
      // 预览弹窗
      dialogVisible: false,
    }
  },
  computed: {
    sortAptitudeList() {
      const list = this.aptitudeList.reduce((pre, item) => {
        const child = pre.find((i) => {
          return i.directoryName === item.directoryName
        })
        if (!child || child === -1) {
          pre.push({
            directoryName: item.directoryName,
            child: [item],
          })
        } else {
          child.child.push(item)
        }
        return pre
      }, [])
      return list
    },
  },
  methods: {
    // 附件，下载
    async downLoadFile(file) {
      // 没有文件名称，先拿文件信息
      const [errFile, resFile] = await fileApi.get(file.fileId)
      if (!errFile) {
        const [err, res] = await fileApi.download(file.fileId, { returnType: 'Blob' })
        if (!err) {
          this.exportFile(res, resFile.name)
        }
      }
    },
    async viewFile(file) {
      const [errFile, resFile] = await fileApi.get(file.fileId)
      if (!errFile) {
        const [err, res] = await fileApi.download(file.fileId, { returnType: 'Blob' })
        const strList = resFile.name.split('.')
        const type = strList[strList.length - 1].toLowerCase()
        const typeMap = {
          pdf: 'application/pdf',
        }
        const imageList = ['jpg', 'png', 'jpg', 'jpeg', 'gif', 'psd', 'bmp', 'tiff']
        if (!typeMap[type] && !(imageList.indexOf(type) > -1)) {
          this.$message.warning({
            showClose: true,
            message: '只支持pdf和图片预览',
          })
          return
        }
        if (imageList.indexOf(type) > -1) {
          const [error, result] = await fileApi.getFileContent(file.fileId)
          if (!error) {
            this.imgContent = `data:image/jpg;base64,${result.content}`
          }
          this.dialogVisible = true
          return
        }
        if (!err) {
          // this.exportFile(res, file.name)
          const blob = new Blob([res], {
            type: typeMap[type] || `image/${type}}`,
          })
          const blobUrl = window.URL.createObjectURL(blob)
          const templink = document.createElement('a')
          templink.style.display = 'none'
          templink.href = blobUrl
          templink.setAttribute('target', '_blank')
          document.body.appendChild(templink)
          templink.click()
          document.body.removeChild(templink)
          window.URL.revokeObjectURL(blobUrl)
        }
      }
    },
    // 下载文件
    exportFile(data, name) {
      const blob = new Blob([data], {
        type: 'application/pdf',
      })
      const blobUrl = window.URL.createObjectURL(blob)
      const templink = document.createElement('a')
      templink.style.display = 'none'
      templink.href = blobUrl
      templink.setAttribute('download', `${name}`)
      document.body.appendChild(templink)
      templink.click()
      document.body.removeChild(templink)
      window.URL.revokeObjectURL(blobUrl)
      this.$message({
        type: 'success',
        showClose: true,
        message: '下载成功!',
      })
    },
    refreshList() {
      this.$emit('back')
    },
    async createApi() {
      this.showOperateApiDialog = true
    },
    async getConfig() {
      this.templateId = this.profileTemplateId
      const [
        err,
        res,
      ] = await profileTemplateGuidanceConfigurationApi.profileTemplateGuidanceConfigurationDetailContentDto(
        {
          // 目前没有商户id 直接从列表查询模板id
          templateId: this.profileTemplateId,
        }
      )
      if (!err) {
        this.aptitudeList = res
      }
    },
  },
  mounted() {
    this.getConfig()
  },
}
</script>

<style scoped lang="scss">
::v-deep .el-card__body {
  // height: calc(100% - 45px);
  height: 100%;
}
.bg_custom {
  background: rgba(237, 240, 249, 0.5);
}
.img_dialog {
  ::v-deep .el-dialog__body {
    padding-top: 0px;
  }
}

.required-text--color {
  color: #ff3a30;
}

.down-file--color {
  color: #acdbff;
}
</style>
